import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { PermissionStore } from '@core/store/permission.store';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class RoutePermissionResolver implements Resolve<any> {
  constructor(private permissionStore: PermissionStore, private permissionService: PermissionService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    const pagePermissions = this.permissionService.getPagePermission(route.data).pipe(
      tap(res => {
        this.permissionStore.setStore(res['data']);
      }),
      catchError(_error => {
        return of([]);
      })
    );
    const lookupPermissions = this.permissionService.getPageLookupPermission().pipe(
      tap(res => {
        this.permissionStore.setStore(res['data'], 'LP');
      }),
      catchError(_error => {
        return of([]);
      })
    );
    return forkJoin([pagePermissions, lookupPermissions]);   // NOSONAR
  }
}
